type Props = {
  primaryColor: string;
};

export default function CallbackIcon({ primaryColor }: Props) {
  const normalized = primaryColor.startsWith("#")
    ? primaryColor
    : `#${primaryColor}`;
  const lightColor = `${normalized}80`;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 245 245"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5127 106.873L24.433 105.901C23.7487 106.166 23.1086 106.475 22.5127 106.873Z"
        style={{ fill: '#229EFF' }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.933 181.458L170.617 166.096L163.465 157.179L150.487 141L145.3 134.533L129.298 136.012L106.343 138.13V190.022L107.491 191.457L145.3 238.603L184.257 234.763V183.113L182.933 181.458ZM138.789 213.242L119.321 188.83V161.769L122.058 165.213L132.873 178.743L134.75 181.105L138.789 186.159V213.242ZM143.645 176.668L136.582 167.861L124.95 153.338L131.88 152.764L145.3 151.682L150.487 158.106L159.205 168.877L160.883 170.952L165.628 176.823L158.168 177.529L145.3 178.743L143.645 176.668ZM171.257 218.826L151.789 220.481V193.421L169.513 191.677L171.257 191.501V218.826Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M171.257 210.746V218.825L151.789 220.48L171.257 210.746Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M171.257 193.838V210.746L151.789 220.479V193.419L169.513 191.675L171.257 193.838Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M138.785 186.158V213.24L119.317 188.828L134.746 181.103L138.785 186.158Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M134.746 181.103L119.317 188.829V161.768L122.054 165.211L132.87 178.742L134.746 181.103Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M165.63 176.821L158.17 177.527L145.302 178.741L155.19 173.797L160.885 170.95L165.63 176.821Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M160.883 170.948L155.188 173.796L145.3 178.74L143.645 176.665L136.582 167.858L124.95 153.335L131.88 152.761L145.3 151.679L150.487 158.102L159.206 168.874L160.883 170.948Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M228.402 161.04V212.689L184.258 234.762V183.113L195.934 177.285L210.701 169.891L228.402 161.04Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M106.342 138.127V190.019L107.49 191.453L95.5048 197.435C89.3026 183.265 85.8372 170.088 85.1309 157.904C84.844 153.092 84.9323 148.479 85.4399 144.065C86.1683 137.355 87.8017 131.13 90.3179 125.392L134.462 103.319C131.372 110.383 129.606 118.174 129.209 126.694L106.342 138.127Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.5051 197.438L15.4497 151.197V123.387C15.4497 117.935 16.6637 113.498 19.1137 110.121C20.0848 108.775 21.1884 107.693 22.4686 106.899H22.5128L24.433 105.906L24.5655 105.839C25.956 105.332 27.5893 105.067 29.2889 105.067C36.6389 105.001 44.938 106.148 54.1862 108.51C55.952 108.951 57.7619 109.481 59.5939 110.077C67.3412 112.593 75.7065 116.456 84.6898 121.643L87.7137 123.409C88.5966 123.894 89.4574 124.579 90.3182 125.395C87.802 131.134 86.1686 137.358 85.4403 144.068C84.9326 148.483 84.8443 153.096 85.1312 157.907C85.8376 170.091 89.3029 183.268 95.5051 197.438Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M134.466 103.319L90.3216 125.391C89.4608 124.575 88.6 123.89 87.7171 123.405L84.6933 121.639C75.7099 116.452 67.3446 112.59 59.5973 110.073C57.7653 109.477 55.9554 108.948 54.1897 108.506C44.9415 106.144 36.6424 104.997 29.2923 105.063C27.5927 105.063 25.9594 105.328 24.5688 105.835L61.1644 87.4936C61.5617 88.1558 61.959 88.7958 62.3784 89.4359C68.7131 99.3684 76.1514 106.785 84.6933 111.707C94.2284 117.203 102.373 118.019 109.149 114.157L133.119 102.172C133.583 102.503 134.024 102.9 134.466 103.319Z"
        style={{ fill: lightColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.322 91.9743C119.322 92.8131 119.3 93.6297 119.256 94.4243C118.77 104.026 115.393 110.581 109.147 114.157C102.37 118.019 94.2258 117.203 84.6907 111.707C76.1488 106.785 68.7105 99.3685 62.3758 89.436C61.9564 88.7959 61.5591 88.1558 61.1618 87.4937C60.8528 86.986 60.5438 86.4563 60.2348 85.9266C53.4587 74.2284 50.0596 62.9054 50.0596 51.9797C50.0596 41.054 53.4587 33.6599 60.2348 29.7973L61.7357 29.0468C68.2028 26.0671 75.8618 27.1486 84.6907 32.2473C88.3988 34.3662 91.8861 36.9709 95.1528 40.061C100.34 44.8948 104.997 50.8761 109.147 58.0275C113.848 66.15 116.916 74.0959 118.373 81.8212C119.013 85.2423 119.322 88.6194 119.322 91.9743Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M163.466 69.9019C163.466 80.8276 160.067 88.2215 153.291 92.0841L151.79 92.8348L133.117 102.171L109.147 114.156C115.393 110.581 118.77 104.025 119.256 94.4238C119.3 93.6292 119.322 92.8127 119.322 91.974C119.322 88.619 119.013 85.242 118.373 81.8208C116.916 74.0956 113.848 66.1497 109.147 58.0271C104.997 50.8758 100.34 44.8943 95.153 40.0605C91.8863 36.9704 88.3989 34.3659 84.6908 32.247C75.862 27.1483 68.203 26.0666 61.7358 29.0463L104.379 7.72482C111.155 3.86221 119.322 4.67886 128.835 10.1748C138.37 15.6707 146.515 24.2789 153.291 35.9551C160.067 47.6533 163.466 58.9762 163.466 69.9019Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M189.444 112.461L150.487 131.951L145.3 134.533L129.298 136.012L106.343 138.131L129.209 126.698L150.487 116.059L189.444 112.461Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M228.403 161.042L210.701 169.892L195.935 177.287L184.259 183.114L182.935 181.458L170.618 166.096L163.467 157.179L150.489 141L145.302 134.533L150.489 131.951L189.446 112.461L228.403 161.042Z"
        style={{ fill: primaryColor }}
        stroke="white"
        strokeWidth="1.1036"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
